module.exports = __webpack_public_path__ + "a85af41c6b35f000a342fe0dac195e84.svg";